var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCheckboxCheckedIcon = function SvgCheckboxCheckedIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1rem",
    height: "1rem",
    viewBox: "0 0 1024 1024"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M810.667 128H213.333C166.4 128 128 166.4 128 213.333v597.334C128 857.6 166.4 896 213.333 896h597.334C857.6 896 896 857.6 896 810.667V213.333C896 166.4 857.6 128 810.667 128zM456.96 695.04a42.496 42.496 0 0 1-60.16 0L243.627 541.867c-8.107-8.107-12.374-18.774-12.374-29.867s4.694-22.187 12.374-29.867a42.496 42.496 0 0 1 60.16 0l122.88 122.454L720.213 311.04a42.496 42.496 0 1 1 60.16 60.16L456.96 695.04z"
  })));
};
export default SvgCheckboxCheckedIcon;